import {TextFieldDefinition} from '../../fields-definitions/text-field-definition';
import {NumericFieldDefinition} from '../../fields-definitions/numeric-field-definition';
import {makeConfigurationArea} from '../make-configuration-area';
import {ILauncherServiceFactory} from '../../../launcher-service-factory.interface';
import {NumericDropDownFieldDefinition} from '../../fields-definitions/numeric-drop-down-field-definition';
import {BooleanFieldDefinition} from '../../fields-definitions/boolean-field-definition';
import {DropDownFieldDefinition} from '../../fields-definitions/drop-down-field-definition';
import {ROOT_CONFIGURATION_KEYS} from '../../root-configuration-keys';



export function makeSdkConfigurationArea(services: ILauncherServiceFactory) {
    return makeConfigurationArea(ROOT_CONFIGURATION_KEYS.sdk, services, {
        server: new DropDownFieldDefinition('SDK client', 'URL from where the SDK java script will be downloaded', [
            {value: 'http://localhost:7070', text: 'DEV - http://localhost:7070'},
            {value: 'http://mirage-cgp-latest-eu.888casino.com', text: 'MIRAGE - http://mirage-cgp-latest-eu.888casino.com'},
            {value: 'http://mgm-cgp-latest-eu.888casino.com', text: 'MGM - http://mgm-cgp-latest-eu.888casino.com'},
            {value: 'http://usqa-cgp-latest-us.888casino.com', text: 'USQA - http://usqa-cgp-latest-us.888casino.com'},
            {value: 'https://cgp-stage-cdn2.safe-iplay.com', text: 'EU_Stage - https://cgp-stage-cdn2.safe-iplay.com'},
            {value: 'https://cgp-cdn2.safe-iplay.com', text: 'EU_Production - https://cgp-cdn2.safe-iplay.com'},
            {value: 'https://cgp-nj.secured-qa.com', text: 'NJPE_Certification - https://cgp-nj.secured-qa.com'},
            {value: 'https://cgp-stg-nj.secured-qa.com', text: 'NJPE_STAGE - https://cgp-stg-nj.secured-qa.com'},
            {value: 'https://cgp-stg-nj.secured-igaming-services.com', text: 'USA_Stage - https://cgp-stg-nj.secured-igaming-services.com'},
            {value: 'https://cgp-nj.secured-igaming-services.com', text: 'USA_Production - https://cgp-nj.secured-igaming-services.com'}
        ]),
        api: new DropDownFieldDefinition('SDK server', 'The CGP SDK backend API URL', [
            {value: 'http://localhost:7070', text: 'DEV - http://localhost:7070'},
            {value: 'http://mirage-cgp-latest-eu.888casino.com', text: 'MIRAGE - http://mirage-cgp-latest-eu.888casino.com'},
            {value: 'http://mgm-cgp-latest-eu.888casino.com', text: 'MGM - http://mgm-cgp-latest-eu.888casino.com'},
            {value: 'http://usqa-cgp-latest-us.888casino.com', text: 'USQA - http://usqa-cgp-latest-us.888casino.com'},
            {value: 'https://cgp-stage.safe-iplay.com', text: 'EU_Stage - https://cgp-stage.safe-iplay.com'},
            {value: 'https://cgp.safe-iplay.com', text: 'EU_Production - https://cgp.safe-iplay.com'},
            {value: 'https://cgp-nj.secured-qa.com', text: 'NJPE_Certification - https://cgp-nj.secured-qa.com'},
            {value: 'https://cgp-stg-nj.secured-qa.com', text: 'NJPE_STAGE - https://cgp-stg-nj.secured-qa.com'},
            {value: 'https://cgp-stg-nj.secured-igaming-services.com', text: 'USA_Stage - https://cgp-stg-nj.secured-igaming-services.com'},
            {value: 'https://cgp-nj.secured-igaming-services.com', text: 'USA_Production - https://cgp-nj.secured-igaming-services.com'}
        ]),
        Skin: {
            regulationID: new NumericDropDownFieldDefinition('Regulation', '', services.regulations.items.map(reg => {
                return {value: reg.id, text: reg.name};
            })),
            brandID: new NumericFieldDefinition('Brand'),
            subBrandID: new NumericFieldDefinition('Sub brand'),
            productPackageID: new NumericDropDownFieldDefinition('Product Package', '', [
                {value: 88, text: 'PC - 88'},
                {value: 89, text: 'IPHONE - 89'},
                {value: 90, text: 'IPAD - 90'},
                {value: 91, text: 'OTHER - 91'},
                {value: 92, text: 'IPHONE NATIVE - 92'},
                {value: 93, text: 'IPAD NATIVE - 93'},
                {value: 94, text: 'OTHER NATIVE - 94'}
            ]),
            responsibleGamblingLink: new TextFieldDefinition('Responsible Gambling URL')
        },
        Currency: {
            anonymousCurrency: new DropDownFieldDefinition('Currency', '', [
                {value: 'USD'},
                {value: 'EUR'},
                {value: 'GBP'},
                {value: 'DKK'},
                {value: 'SEK'},
                {value: 'RON'},
                {value: 'NOK'},
                {value: 'CAD'}
            ])
        },
        OAuth2: {
            fakeClientIP: new DropDownFieldDefinition('Simulate IP', '', [
                {value: '213.219.55.4', text: 'UK'},
                {value: '5.62.83.160', text: 'Malta'},
                {value: '2.16.6.0', text: 'Germany'},
            ])
        },
        NetEnt: {
            isGameInclusionEnabled: new BooleanFieldDefinition('Use NetEnt Reintegration')
        },
        Evolution: {
            useNewIntegration: new BooleanFieldDefinition('Use Evolution New Integration')
        },
        RedTiger: {
            useAdapter: new BooleanFieldDefinition('Use adapter for launching Red Tiger games')
        },
        BlueRibbon: {
            enabled: new BooleanFieldDefinition('Use Blue Ribbon')
        },
        Regulation: {
            realityCheckEnabledForDk: new BooleanFieldDefinition('DK Enable Reality Check')
        },
        debug: new BooleanFieldDefinition('Debug')
    });
}